import { configureStore } from "@reduxjs/toolkit";
import { blumenApi } from "./api";

export const store = configureStore({
	reducer: {
		[blumenApi.reducerPath]: blumenApi.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(blumenApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
